<template>
  <div class="page-box">
    <div class="config-nav-name" data-type="productCatelogue" :data-id="id" style="display:none">
      {{ title || "商品目录" }}
    </div>
    <!-- 修改后的 Header 部分 -->
    <div class="section-header" v-if="title">
      <div class="title-container">
        <h2 class="section-title">{{ title }}</h2>
      </div>
    </div>
    <div class="catalog-container">
      <!-- 布局 1-1: 单级目录直接展示 -->
      <div class="layout-content" v-if="['1-1'].includes(layout.style)">
        <div class="category-grid" ref="categoryGrid1">
          <div class="category-card cursor-pointer" v-for="dom in showList" :key="dom.id" @click="toProductList(dom)">
            <div class="category-image">
              <img
                class="categoryImg"
                :style="imgHeight ? 'height:' + imgHeight : ''"
                :src="dom.picture || defaultcatlogpic"
                alt=""
              />
              <div class="category-overlay">
                <i class="fas fa-arrow-right overlay-icon"></i>
              </div>
            </div>
            <div class="category-name">
              <span>{{ dom.name }}</span>
            </div>
          </div>
        </div>

        <!-- 布局 1-1 分页 -->
        <div class="pagination-container" v-if="showPagination">
          <div class="pagination">
            <button class="page-btn prev-btn" @click="lastPage">
              <i class="fas fa-chevron-left"></i>
              <span>上一页</span>
            </button>
            <!-- <div class="page-numbers">
            <button class="page-number active">1</button>
            <button class="page-number">2</button>
            <button class="page-number">3</button>
            <span class="page-ellipsis">...</span>
            <button class="page-number">8</button>
          </div> -->
            <button class="page-btn next-btn" @click="nextPage">
              <span>下一页</span>
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 布局 1-2: 左侧分类 + 右侧商品 -->
      <div class="layout-content horizontal-layout" v-else-if="['1-2'].includes(layout.style)">
        <div class="category-sidebar">
          <div
            class="category-item"
            :class="{ active: chooseItem.id === item.id }"
            @click="changeMl(item)"
            v-for="item in listData"
            :key="item.id"
          >
            <div class="category-icon">
              <i class="fas fa-folder"></i>
            </div>
            <span class="category-text">{{ item.name }}</span>
          </div>
        </div>

        <div class="content-panel">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-decoration"></div>
              <span>{{ chooseItem.name }}</span>
            </div>
            <div class="view-more cursor-pointer" v-show="chooseItem.showMore" @click="toProductList(chooseItem)">
              <span>查看更多</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
          <div class="scroll-div" ref="scrollContainer2">
            <div class="product-grid" v-newloading="loading">
              <template v-for="item in goodsList">
                <ProductOne @refresh="getGoods" :info="item" :key="item.uuid"></ProductOne>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 1-3: 顶部导航 + 商品展示 -->
      <div class="layout-content" v-else-if="['1-3'].includes(layout.style)">
        <NavBar :list="listData" label="name" value="id" @change="obj => this.changeMl(obj.item)"></NavBar>

        <div class="content-panel m-t-16">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-decoration"></div>
              <span>{{ chooseItem.name }}</span>
            </div>
            <div class="view-more cursor-pointer" v-show="chooseItem.showMore" @click="toProductList(chooseItem)">
              <span>查看更多</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>

          <div class="product-grid grid-5" v-newloading="loading">
            <template v-for="item in goodsList">
              <ProductOne @refresh="getGoods" :info="item" :key="item.uuid"></ProductOne>
            </template>
          </div>
        </div>
      </div>

      <!-- 布局 2-1: 顶部导航 + 二级分类 -->
      <div class="layout-content" v-else-if="['2-1'].includes(layout.style)">
        <NavBar :list="listData" label="name" value="id" @change="obj => this.getSecondMlByfirstChoose(obj)"></NavBar>

        <div class="content-panel m-t-16">
          <div class="category-grid" ref="categoryGrid2">
            <div class="category-card cursor-pointer" v-for="dom in showList" :key="dom.id" @click="toProductList(dom)">
              <div class="category-image">
                <img
                  class="categoryImg"
                  :style="imgHeight ? 'height:' + imgHeight : ''"
                  :src="dom.picture || defaultcatlogpic"
                  alt=""
                />
                <div class="category-overlay">
                  <i class="fas fa-arrow-right overlay-icon"></i>
                </div>
              </div>
              <div class="category-name">
                <span>{{ dom.name }}</span>
              </div>
            </div>
          </div>

          <!-- 布局 2-1 分页 -->
          <div class="pagination-container" v-if="showPagination">
            <div class="pagination">
              <button class="page-btn prev-btn" @click="lastPage">
                <i class="fas fa-chevron-left"></i>
                <span>上一页</span>
              </button>
              <button class="page-btn next-btn" @click="nextPage">
                <span>下一页</span>
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 2-2: 左侧分类 + 右侧二级分类 -->
      <div class="layout-content horizontal-layout" v-else-if="['2-2'].includes(layout.style)">
        <div class="category-sidebar">
          <div
            class="category-item"
            :class="{ active: chooseItem.id === item.id }"
            @click="changeMl(item)"
            v-for="item in listData"
            :key="item.id"
          >
            <div class="category-icon">
              <i class="fas fa-folder"></i>
            </div>
            <span class="category-text">{{ item.name }}</span>
          </div>
        </div>

        <div class="content-panel">
          <div class="panel-header">
            <div class="panel-title">
              <div class="title-decoration"></div>
              <span>{{ chooseItem.name }}</span>
            </div>
            <div class="view-more cursor-pointer" @click="toProductList(chooseItem)">
              <span>查看更多</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>

          <div class="category-grid">
            <div
              class="category-card cursor-pointer"
              v-for="dom in secondList"
              :key="dom.id"
              @click="toProductList(dom)"
            >
              <div class="category-image">
                <img
                  :src="dom.picture || defaultcatlogpic"
                  class="categoryImg"
                  :style="imgHeight ? 'height:' + imgHeight : ''"
                  alt=""
                />
                <div class="category-overlay">
                  <i class="fas fa-arrow-right overlay-icon"></i>
                </div>
              </div>
              <div class="category-name">
                <span>{{ dom.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 2-3: 左侧分类 + 右侧商品(多二级分类) -->
      <div class="layout-content horizontal-layout" v-else-if="['2-3'].includes(layout.style)">
        <div class="category-sidebar">
          <div
            class="category-item"
            :class="{ active: chooseItem.id === item.id }"
            @click.stop="changeMl(item)"
            v-for="item in listData"
            :key="item.id"
          >
            <div class="category-icon">
              <i class="fas fa-folder"></i>
            </div>
            <span class="category-text">{{ item.name }}</span>
          </div>
        </div>
        <div class="scroll-div flex1" ref="scrollContainer2">
          <div class="content-panel">
            <div v-for="item in secondList" :key="item.id" class="subcategory-section">
              <div class="panel-header">
                <div class="panel-title">
                  <div class="title-decoration"></div>
                  <span>{{ item.name }}</span>
                </div>
                <div class="view-more cursor-pointer" v-show="item.showMore" @click="toProductList(item)">
                  <span>查看更多</span>
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>

              <div class="product-grid" v-if="item.children" v-newloading="loading">
                <template v-for="product in item.children">
                  <ProductOne @refresh="getGoodsloop" :info="product" :key="product.uuid"></ProductOne>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 2-4: 顶部导航 + 商品(多二级分类) -->
      <div class="layout-content" v-else-if="['2-4'].includes(layout.style)">
        <NavBar :list="listData" label="name" value="id" @change="obj => this.changeMl(obj.item)"></NavBar>

        <div class="content-panel m-t-16">
          <div v-for="item in secondList" :key="item.id" class="subcategory-section">
            <div class="panel-header">
              <div class="panel-title">
                <div class="title-decoration"></div>
                <span>{{ item.name }}</span>
              </div>
              <div class="view-more cursor-pointer" v-show="item.showMore" @click="toProductList(item)">
                <span>查看更多</span>
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div class="product-grid grid-5" v-if="item.children" v-newloading="loading">
              <template v-for="product in item.children">
                <ProductOne @refresh="getGoodsloop" :info="product" :key="product.uuid"></ProductOne>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 3-1: 左侧分类 + 右侧三级分类 -->
      <div class="layout-content horizontal-layout" v-else-if="['3-1'].includes(layout.style)">
        <div class="category-sidebar">
          <div
            class="category-item"
            :class="{ active: chooseItem.id === item.id }"
            @click="changeMl(item)"
            v-for="item in listData"
            :key="item.id"
          >
            <div class="category-icon">
              <i class="fas fa-folder"></i>
            </div>
            <span class="category-text">{{ item.name }}</span>
          </div>
        </div>

        <div class="content-panel">
          <div v-for="item in secondList" :key="item.id" class="subcategory-section">
            <div class="panel-header">
              <div class="panel-title">
                <div class="title-decoration"></div>
                <span>{{ item.name }}</span>
              </div>
              <div class="view-more cursor-pointer" @click="toProductList(item)">
                <span>查看更多</span>
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div class="category-grid">
              <div
                class="category-card cursor-pointer"
                v-for="dom in item.children"
                :key="dom.id"
                @click="toProductList(dom)"
              >
                <div class="category-image">
                  <img
                    :src="dom.picture || defaultcatlogpic"
                    class="categoryImg"
                    :style="imgHeight ? 'height:' + imgHeight : ''"
                    alt=""
                  />
                  <div class="category-overlay">
                    <i class="fas fa-arrow-right overlay-icon"></i>
                  </div>
                </div>
                <div class="category-name">
                  <span>{{ dom.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 布局 3-2: 顶部导航 + 三级分类 -->
      <div class="layout-content" v-else-if="['3-2'].includes(layout.style)">
        <NavBar :list="listData" label="name" value="id" @change="obj => this.changeMl(obj.item)"></NavBar>

        <div class="content-panel m-t-16">
          <div v-for="item in secondList" :key="item.id" class="subcategory-section">
            <div class="panel-header">
              <div class="panel-title">
                <div class="title-decoration"></div>
                <span>{{ item.name }}</span>
              </div>
              <div class="view-more cursor-pointer" @click="toProductList(item)">
                <span>查看更多</span>
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div class="category-grid">
              <div
                class="category-card cursor-pointer"
                v-for="dom in item.children"
                @click="toProductList(dom)"
                :key="dom.id"
              >
                <div class="category-image">
                  <img
                    :src="dom.picture || defaultcatlogpic"
                    class="categoryImg"
                    :style="imgHeight ? 'height:' + imgHeight : ''"
                    alt=""
                  />
                  <div class="category-overlay">
                    <i class="fas fa-arrow-right overlay-icon"></i>
                  </div>
                </div>
                <div class="category-name">
                  <span>{{ dom.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsList } from "@/api/goods";
// import ProductOne from "../products/components/Product";
import NavBar from "../common/NavBar";
import defaultcatlogpic from "@/assets/img/newProducts/deafultcatlogpic.jpeg";

export default {
  components: {
    // ProductOne: () => ({
    //   component: import("@/views/newProducts/components/products/components/Product"),
    //   loading: {
    //     template: '<div class="component-loading">加载中...</div>'
    //   },
    //   error: {
    //     template: '<div class="component-error">组件加载失败</div>'
    //   },
    //   timeout: 1000
    // }),
    ProductOne: () => import("@/views/newProducts/components/products/components/Product"),
    NavBar
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    layout: {
      type: Object,
      default: () => {}
    },
    setting: {
      type: Number,
      default: -1
    },
    title: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    list: {
      handler(newV) {
        if (newV && newV.length > 0) {
          this.listData = newV;
          if (this.listData.length === 0) {
            return;
          }
          this.firtsChooseId = this.listData[0].id;
          this.chooseItem = window.tool.deepClone(this.listData[0]);
          this.secondList = window.tool.deepClone(this.listData[0].children || []);
          if (["1-2", "1-3"].includes(this.layout.style)) {
            this.getGoods();
          }
          if (["2-3", "2-4"].includes(this.layout.style)) {
            this.getGoodsloop();
          }
          if (["1-1", "2-1"].includes(this.layout.style)) {
            // 在列表更新后计算卡片数量
            this.$nextTick(() => {
              this.calculateCardsPerRow();
            });
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.setImgHeight();
              this.$bus.$emit("resetLeftNav");
            }, 100);
          });
        }
      },
      deep: true,
      immediate: true
    },
    layout: {
      handler(newV) {
        // 布局变化时重新计算卡片数量
        this.$nextTick(() => {
          this.calculateCardsPerRow();
        });
      },
      deep: true
    }
  },
  data() {
    return {
      imgHeight: "",
      loading: false,
      firtsChooseId: -1,
      secondList: [],
      chooseItem: {},
      goodsList: [],
      defaultcatlogpic,
      cardsPerRow: 0,
      showPagination: false,
      pageIndex: 1,
      showList: [],
      listData: []
    };
  },
  mounted() {
    // 初始计算卡片数量
    // this.$nextTick(() => {
    //   this.calculateCardsPerRow();
    // });

    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    // 添加内部滚动容器的滚动监听
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", this.scrollFuns);
    }
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("resize", this.handleResize);
    // 移除内部滚动容器的滚动监听
    const scrollContainer = this.$refs.scrollContainer;
    if (scrollContainer) {
      scrollContainer.removeEventListener("scroll", this.scrollFuns);
    }
  },
  methods: {
    closeTooltip() {
      let list = document.getElementsByClassName("el-tooltip__popper");
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
    },
    scrollFuns() {
      this.closeTooltip();
    },
    lastPage() {
      this.pageIndex--;
      if (this.pageIndex < 1) {
        this.pageIndex = 1;
      }
      this.setPagination();
    },
    nextPage() {
      let list = [];
      if (["1-1"].includes(this.layout.style)) {
        list = this.listData;
      }
      if (["2-1"].includes(this.layout.style)) {
        list = this.secondList;
      }
      this.pageIndex++;
      if (this.pageIndex > Math.ceil(list.length / (this.layout.size * this.cardsPerRow))) {
        this.pageIndex = Math.ceil(list.length / (this.layout.size * this.cardsPerRow));
      }
      if (this.pageIndex > this.layout.count) {
        this.pageIndex = this.layout.count;
      }
      this.setPagination();
    },
    setPagination() {
      let list = [];
      if (["1-1"].includes(this.layout.style)) {
        list = this.listData;
      }
      if (["2-1"].includes(this.layout.style)) {
        list = this.secondList;
      }
      this.showList = [];
      list.forEach((e, index) => {
        if (
          index < this.pageIndex * this.layout.size * this.cardsPerRow &&
          index >= (this.pageIndex - 1) * this.layout.size * this.cardsPerRow
        ) {
          this.showList.push(e);
        }
      });
    },
    //动态设置图片的高度
    setImgHeight() {
      const imgElement = document.getElementsByClassName("categoryImg")[0];
      console.log("imgElement", imgElement);
      if (imgElement) {
        this.imgHeight = imgElement.clientWidth + "px";
      }
    },
    // 计算一行有多少个.category-card元素
    calculateCardsPerRow() {
      // 只在布局1-1和2-1时计算
      if (!["1-1", "2-1"].includes(this.layout.style)) {
        this.showPagination = false;
        return;
      }
      let gridElement;

      if (this.layout.style === "1-1") {
        gridElement = this.$refs.categoryGrid1;
      } else if (this.layout.style === "2-1") {
        gridElement = this.$refs.categoryGrid2;
      }

      if (!gridElement) {
        this.showPagination = false;
        return;
      }

      // 获取网格容器的计算样式
      const gridStyle = window.getComputedStyle(gridElement);

      // 获取网格模板列的值
      const gridTemplateColumns = gridStyle.getPropertyValue("grid-template-columns");

      if (gridTemplateColumns && gridTemplateColumns !== "none") {
        // 计算列数 - 通过分割空格来获取列数
        const columns = gridTemplateColumns.split(" ").filter(col => col.trim() !== "").length;
        this.cardsPerRow = columns;

        // console.log(`当前布局: ${this.layout.style}, 每行卡片数量: ${this.cardsPerRow}`);

        // 根据卡片数量决定是否显示分页
        // 这里可以根据实际需求调整条件，例如当卡片超过一定数量时显示分页
        // this.showPagination = this.cardsPerRow > 0;
      } else {
        // 备用方案：通过计算单个卡片宽度和容器宽度来估算
        const gridWidth = gridElement.clientWidth;
        const cardElements = gridElement.querySelectorAll(".category-card");

        if (cardElements.length > 0) {
          const firstCard = cardElements[0];
          const cardStyle = window.getComputedStyle(firstCard);
          const cardWidth = firstCard.offsetWidth;
          const gap = parseInt(gridStyle.getPropertyValue("grid-column-gap")) || 20;

          // 估算一行可以容纳的卡片数量
          this.cardsPerRow = Math.floor((gridWidth + gap) / (cardWidth + gap));
          // this.showPagination = this.cardsPerRow > 0;

          // console.log(`备用计算 - 当前布局: ${this.layout.style}, 每行卡片数量: ${this.cardsPerRow}`);
        } else {
          this.cardsPerRow = 0;
          this.showPagination = false;
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.setImgHeight();
        }, 100);
      });
      let list = [];
      if (["1-1"].includes(this.layout.style)) {
        list = this.listData;
      }
      if (["2-1"].includes(this.layout.style)) {
        list = this.secondList;
      }
      if (!this.layout.split) {
        this.showList = list;
        return;
      }
      this.showPagination = list.length / (this.layout.size * this.cardsPerRow) > 1;
      this.setPagination();
    },

    // 处理窗口大小变化
    handleResize() {
      // 使用防抖避免频繁计算
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.calculateCardsPerRow();
      }, 250);
    },

    //点击跳转商品列表
    toProductList(item) {
      const obj = {
        areaId: item.id,
        type: -1,
        setting: this.setting,
        // 首页商品目录进入：列表 search 传 v=3，主目录快照冻结
        fromHomeCatalog: true
      };
      if (this.setting === 0) {
        obj.brand = item.name;
      }
      if (this.setting === 1) {
        obj.category = item.name;
      }
      if (this.setting === 4) {
        obj.productionPlace = item.name;
      }
      this.$store.commit("search/setSearchData", obj);
      this.$router.push({ path: "/new-products/product-list" });
    },
    //循环获取商品
    async getGoodsloop() {
      this.loading = true;
      try {
        for (let i = 0; i < this.secondList.length; i++) {
          const item = this.secondList[i];
          const params = {
            areaId: item.id,
            page: 1,
            pageSize: this.layout.size
          };
          if (this.setting === 0) {
            params.brand = item.name;
          }
          if (this.setting === 1) {
            params.category = item.name;
          }
          if (this.setting === 4) {
            params.productionPlace = item.name;
          }
          let res = await getGoodsList(params);
          item.showMore = res.totalSize > this.layout.size;
          item.children = res.rows;
        }
      } catch (error) {
        item.children = [];
      }
      this.loading = false;
    },
    //获取商品
    async getGoods() {
      const params = {
        areaId: this.chooseItem.id,
        page: 1,
        pageSize: this.layout.size
      };
      if (this.setting === 0) {
        params.brand = this.chooseItem.name;
      }
      if (this.setting === 1) {
        params.category = this.chooseItem.name;
      }
      if (this.setting === 4) {
        params.productionPlace = this.chooseItem.name;
      }
      this.loading = true;
      try {
        let res = await getGoodsList(params);
        this.goodsList = res.rows;
        this.chooseItem.showMore = res.totalSize > this.layout.size;
      } catch (error) {}
      this.loading = false;
    },
    getSecondMlByfirstChoose(obj) {
      const item = obj.item;
      this.secondList = window.tool.deepClone(item.children || []);

      // 在二级列表更新后重新计算卡片数量
      this.$nextTick(() => {
        this.pageIndex = 1;
        this.calculateCardsPerRow();
      });
    },
    changeMl(item) {
      this.firtsChooseId = item.id;
      this.chooseItem = window.tool.deepClone(item);
      this.secondList = window.tool.deepClone(item.children || []);
      if (["1-2", "1-3"].includes(this.layout.style)) {
        this.getGoods();
      }
      if (["2-3", "2-4"].includes(this.layout.style)) {
        this.getGoodsloop();
      }

      // 在分类切换后重新计算卡片数量
      this.$nextTick(() => {
        this.calculateCardsPerRow();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-div {
  max-height: 520px;
  overflow-y: auto;
  padding: 10px;
}
.page-box {
  background: #fff;
  padding: 12px 0;
}
.catalog-container {
  background: #fff;
  border-radius: 2px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin: 12px 0;
  transition: box-shadow 0.3s ease;
  will-change: box-shadow;

  &:hover {
    // box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  }
}

/* 修改后的 Header 样式 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 4px;
  padding-left: 12px;
  // background: linear-gradient(145deg, #f8faff, #ffffff);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.title-container {
  .section-title {
    font-size: 20px;
    font-weight: 800;
    color: var(--color-primary);
    margin: 0 0 4px 0;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 40px;
      height: 3px;
      background: linear-gradient(90deg, var(--color-light80), var(--color-primary-dark30));
      border-radius: 2px;
    }
  }

  .section-subtitle {
    font-size: 14px;
    color: #666;
    margin: 16px 0 0 0;
  }
}

.layout-indicator {
  .layout-badge {
    background: linear-gradient(135deg, var(--color-light80), var(--color-primary-dark30));
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(79, 107, 255, 0.3);
  }
}

.layout-content {
  padding: 4px 12px;

  &.horizontal-layout {
    display: flex;
    gap: 20px;
  }
}

.category-sidebar {
  width: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px 0;
  flex-shrink: 0;

  .category-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;

    &:hover {
      background: rgba(79, 107, 255, 0.1);
      border-left-color: var(--color-primary-dark10);

      .category-icon {
        color: var(--color-primary-dark10);
      }

      .category-text {
        color: var(--color-primary);
      }
    }

    &.active {
      background: rgba(79, 107, 255, 0.15);
      border-left-color: var(--color-primary);

      .category-icon {
        color: var(--color-primary);
      }

      .category-text {
        color: var(--color-primary);
        font-weight: 600;
      }
    }

    .category-icon {
      width: 24px;
      margin-right: 10px;
      color: #666;
      transition: color 0.2s ease;
    }

    .category-text {
      font-size: 14px;
      color: #333;
      transition: color 0.2s ease;
    }
  }
}

.content-panel {
  flex: 1;

  .subcategory-section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaeaea;

  .panel-title {
    display: flex;
    align-items: center;

    .title-decoration {
      width: 4px;
      height: 20px;
      background: linear-gradient(135deg, var(--color-light80), var(--color-primary-dark30));
      border-radius: 2px;
      margin-right: 10px;
    }

    span {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .view-more {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--color-primary);
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      color: var(--color-primary-dark10);
      gap: 8px;
    }
  }
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;

  .category-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);

      .category-overlay {
        opacity: 1;
      }
    }

    .category-image {
      position: relative;
      overflow: hidden;
      // height: 120px;
      height: auto;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      .category-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(79, 107, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;

        .overlay-icon {
          color: white;
          font-size: 20px;
        }
      }
    }

    .category-name {
      padding: 12px;
      text-align: center;

      span {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}

.product-grid {
  display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-template-columns: repeat(auto-fill, minmax(230px, 280fr));
  // grid-template-columns: repeat(4, 1fr);
  gap: 2px;
}
.grid-5 {
  // grid-template-columns: repeat(5, 1fr);
}
/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #eaeaea;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: rgba(79, 107, 255, 0.1);
    border-color: var(--color-primary);
    color: var(--color-primary);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.page-numbers {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(.active) {
    background: rgba(79, 107, 255, 0.1);
    border-color: var(--color-primary);
    color: var(--color-primary);
  }

  &.active {
    background: linear-gradient(135deg, var(--color-light80), var(--color-primary-dark30));
    border-color: var(--color-primary);
    color: white;
  }
}

.page-ellipsis {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  font-size: 14px;
  color: #666;
}

.cursor-pointer {
  cursor: pointer;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .horizontal-layout {
    flex-direction: column;
  }

  .category-sidebar {
    width: 100%;
    display: flex;
    overflow-x: auto;
    padding: 12px;

    .category-item {
      flex-shrink: 0;
      border-left: none;
      border-bottom: 3px solid transparent;

      &:hover,
      &.active {
        border-left-color: transparent;
        border-bottom-color: var(--color-primary);
      }
    }
  }

  .category-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 16px;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 2px;
  }

  .pagination {
    gap: 4px;
  }

  .page-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .page-number {
    min-width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .page-ellipsis {
    min-width: 32px;
    height: 32px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .layout-content {
    padding: 16px;
  }

  .panel-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    .view-more {
      align-self: flex-end;
    }
  }

  .category-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 12px;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 2px;
  }

  .pagination-container {
    margin-top: 24px;
    padding-top: 20px;
  }

  .pagination {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
